import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import {
  labelFeature,
  pipelineFeature,
  stepFeature,
  methodTypeFeature,
  TelespotStepEffects,
  TelespotMethodTypeEffects,
  TelespotPipelineEffects,
  protocolFeature,
  TelespotProtocolEffects,
  TelespotLabelEffects,
} from './state';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(protocolFeature),
    StoreModule.forFeature(stepFeature),
    StoreModule.forFeature(labelFeature),
    StoreModule.forFeature(pipelineFeature),
    StoreModule.forFeature(methodTypeFeature),
    EffectsModule.forFeature([
      TelespotStepEffects,
      TelespotLabelEffects,
      TelespotPipelineEffects,
      TelespotMethodTypeEffects,
      TelespotProtocolEffects,
    ]),
  ],
})
export class TelespotProtocolsDataAccessModule {}
